<dx-load-panel [shading]="true" [visible]="loading"></dx-load-panel>
<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
  <!-- START navbar header-->
  <div class="navbar-header">
    <a class="navbar-brand" [routerLink]="['/']">
      <div class="brand-logo text-left">
        <img class="img-fluid" src="assets/img/logo.png" alt="App Logo" style="height: 40px" />
      </div>
      <div class="brand-logo-collapsed mb-2" style="padding: 0 5px">
        <img
          class="img-fluid"
          src="assets/img/logo-single.png"
          alt="App Logo"
          style="height: 30px"
        />
      </div>
    </a>
  </div>
  <!-- END navbar header-->
  <!-- START Left navbar-->
  <ul class="navbar-nav">
    <li class="nav-item">
      <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
      <a
        class="nav-link d-none d-md-block d-lg-block d-xl-block"
        trigger-resize=""
        (click)="collapseSidebar()"
      >
        <!--  (click)="toggleSidebar()" *ngIf="!isCollapsedText()" -->
        <em>
          <fa-icon [icon]="faBars"></fa-icon>
        </em>
      </a>
      <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
      <a
        class="nav-link sidebar-toggle d-md-none"
        (click)="toggleSidebar(); $event.stopPropagation()"
      >
        <!-- (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()" -->
        <em>
          <fa-icon [icon]="faBars"></fa-icon>
        </em>
      </a>
    </li>
  </ul>
  <ul class="navbar-nav mr-auto flex-row">
    <li class="nav-item">
      <h4 class="text-white mt-2 mr-2">{{ applicationTitle }}</h4>
    </li>
  </ul>
  <!-- END Left navbar-->
  <ul class="navbar-nav flex-row">
    <!-- START Alert menu-->

    <app-timer></app-timer>

    <li class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret pointer" dropdownToggle>
        <em>
          <fa-icon [icon]="faUser"></fa-icon>
        </em>
        {{ username }}
      </a>
      <!-- START Dropdown menu-->
      <div *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
        <div class="dropdown-item">
          <!-- START list group-->
          <div class="list-group">
            <!-- list item-->
            <div class="list-group-item list-group-item-action">
              <div class="media" (click)="changePassword()">
                <div class="align-self-start mr-2">
                  <em>
                    <fa-icon [icon]="faLock"></fa-icon>
                  </em>
                </div>
                <div class="media-body">
                  <p class="m-0"><span class="pointer">Αλλαγή Κωδικού</span></p>
                </div>
              </div>
            </div>
            <!-- list item-->
            <div class="list-group-item list-group-item-action">
              <div class="media" (click)="logout()">
                <div class="align-self-start mr-2">
                  <em>
                    <fa-icon icon="sign-out-alt"></fa-icon>
                  </em>
                </div>
                <div class="media-body">
                  <p class="m-0"><span class="pointer">Αποσύνδεση</span></p>
                </div>
              </div>
            </div>
          </div>
          <!-- END list group-->
        </div>
      </div>
      <!-- END Dropdown menu-->
    </li>
    <!-- END Alert menu-->
  </ul>
  <!-- END Right Navbar-->
</nav>
<!-- END Top Navbar-->
<app-reset-password></app-reset-password>
